<div class="group-container ya-typography" (swiperight)="SwiperNavigateBack()">
  <ya-subheader class="ya-header-title-wrapper" [hasContent]="true"></ya-subheader>
  <div class="ya-page-content ya-page-content--webshop ya-page-content--inset ya-page-content--aligncenter">
    <div class="group-content">
      <div class="group-join">
        <!--Join Group-->
        <div class="joinGroup-selector-container">
          <div a11y_Button class="service-button">
            <div class="content-container">
              <div class="icon-container">
                <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-gruppe-beitreten"></div>
              </div>
              <h2 class="title" langkey="phGroupOrder_CreateGroup_JoinGroup_Header"></h2>
              <span class="text content-container--subfont" langkey="phGroupOrder_CreateGroup_JoinGroup_Desc"></span>
              <div class="botton-wrapper">
                <div class="ya-webshop-button-container">
                  <button a11y_Button mat-flat-button type="submit" (click)="joinGroup()">
                    <span langkey="phGroupOrder_CreateGroup_Join_Btn"></span></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="group-name">
        <div class="icon-container">
          <div class="inline-icon" inlineSVG="shop-icons.svg#ya-hypersoft-user-multi"></div>
        </div>
        <div class="orderMode-info-wrapper">
          <div class="group-info-item title-margin">
            <h2 langkey="phGroupOrder_CreateGroup_Header"></h2>
            <ng-container *ngIf="hasProposedGroupNames$ | async; let hasGroupNames">
              <p class="text content-container--subfont" langkey="phGroupOrder_CreateGroup_Subtext"></p>
            </ng-container>
          </div>
        </div>
        <!--Toggle group name-->
        <div class="button-group" [class.empty]="!(hasProposedGroupNames$ | async)">
          <div class="button-list">
            <mat-button-toggle-group #toggleGroupName="matButtonToggleGroup">
              <ng-container *ngFor="let groupName of (proposedGroupNames$ | async);">
                <div class="ya-button-container">
                  <mat-button-toggle [(value)]="groupName.name" (change)="SelectToggleGroupName($event)"
                    [disableRipple]="true">
                    <span>{{groupName.name}}</span>
                  </mat-button-toggle>
                </div>
              </ng-container>
            </mat-button-toggle-group>
            <div class="group-name-inupt-form">
              <div class="ya-input-container">
                <div class="ya-input-wrapper">
                  <div class="inputs-text">
                    <input a11y_Input type="text" class="ya-input-text input-group-button" (blur)="setWebView()"
                      (change)="ClearToggleValue()" [placeholder]="inputPlaceholder"
                      [formControl]="groupNameInputFormControl">
                  </div>
                  <ng-container
                    *ngIf="groupNameInputFormControl.touched && groupNameInputFormControl.invalid && selectedGroupName =='' ">
                    <ng-container *ngIf="groupNameInputFormControl.errors && activeError(groupNameInputFormControl, field.GroupName)">
                      <ya-errorvalidation [controlValidation]="true"
                        [errorMessage]="activeError(groupNameInputFormControl, field.GroupName)"></ya-errorvalidation>
                    </ng-container>
                  </ng-container>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="group-info-item userName-input_content">
          <p class="text content-container--subfont" langkey="phGroupOrder_GroupCreated_UserName_Input_Info"></p>
        </div>
        <div class="group-name-inupt-form">
          <div class="ya-input-container">
            <div class="ya-input-wrapper">
              <div class="inputs-text">
                <input a11y_Input type="text" class="ya-input-text input-single-button textsize" (blur)="setWebView()"
                  [placeholder]="nameInputPlaceholder" [formControl]="userNameInputFormControl">
              </div>
              <ng-container *ngIf="userNameInputFormControl.touched && userNameInputFormControl.invalid">
                <ng-container *ngIf="userNameInputFormControl.errors && activeError(userNameInputFormControl, field.UserName)">
                  <ya-errorvalidation [controlValidation]="true"
                    [errorMessage]="activeError(userNameInputFormControl, field.UserName)"></ya-errorvalidation>
                </ng-container>
              </ng-container>
            </div>
          </div>
        </div>
        <div class="botton-wrapper">
          <div class="ya-webshop-button-container">
            <ng-container
              *ngIf="setBtnStateByGroupName() && setBtnStateByUserName() then activeButton else deactiveButton">
            </ng-container>
            <ng-template #activeButton>
              <button a11y_Button mat-flat-button type="submit" (click)="CreateGroupAndNavigate()">
                <span langkey="phGroupOrder_CreateGroup_Create"></span></button>
            </ng-template>
            <ng-template #deactiveButton>
              <button mat-flat-button disabled><span langkey="phGroupOrder_CreateGroup_Create"></span></button>
            </ng-template>
          </div>
        </div>
      </div>
    </div>
  </div>